<template>
  <div class="tree-menu">
    <div class="label-wrapper">
      <div :style="indent" :class="showHand">
        <div v-if="hasChildren && !expanded" class='plus' @click="toggleChildren">+</div>
        <div v-if="hasChildren && expanded" class='minus' @click="toggleChildren">-</div>
        <div v-if="!hasChildren" class='space'>&nbsp;</div>
        <div class='link'>
          <router-link class="menulink"
                       :to="{ path: '/ShowProductsofCat', query: { id: catid, level: level, category: name } }">
            {{ name }}
          </router-link>
          <router-link class="delcat"
                       :to="{ path: '/DeleteCategory', query: { id: catid, category: name } }">
            DEL
          </router-link>
          <router-link v-if="!hasChildren" class="addproduct"
                       :to="{ path: '/AddProduct', query: { id: catid, level: level, category: name } }">
            Add product
          </router-link>
          <div class="nextline">
            <router-link class="addsubcat"
                         :to="{ path: '/AddSubcat', query: { id: catid, level: level, parentcategory: name } }">
              Add subcategory
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <Comp_TreeView :class="expanded_or_collapsed"
                    v-for="child in children"
                    :children="child.children"
                    :name="child.categoryname"
                    :catid="child.id"
                    :level="level + 1" v-bind:key="child">
    </Comp_TreeView>
  </div>
</template>

<script>
export default {
  name: 'Comp_TreeView',
  props: ['children', 'name', 'catid', 'level'],
  data() {
    return {
      expanded: true
    }
  },
  computed: {
    showHand() {
      return { 'has-children': this.children }
    },
    hasChildren() {
      return this.children
    },
    indent() {
      return { transform: 'translate(' + ((this.level - 1) * 25) + 'px)' }
    },
    expanded_or_collapsed() {
      return {
        'expanded': this.expanded,
        'collapsed': !this.expanded
      }
    }
  },
  methods: {
    toggleChildren() {
      this.expanded = !this.expanded;
    },
    linkClicked(e) {
      alert("Cat Id of this node: " + e.target.id);
    }
  }
}
</script>

<style scoped>
  .plus, .minus, .link {
    float: left;
  }

  .plus, .minus {
    margin-right: 5px;
    color: cornflowerblue;
  }

  .space {
    float: left;
    margin-right: 10px;
  }

  .tree-menu .label-wrapper {
    padding-bottom: 25px;
    margin-bottom: 15px;
  }

  .tree-menu .has-children {
    cursor: pointer;
  }

  .hyperlink {
    text-decoration: none;
  }

  .expanded {
    max-height: 5000px; /* the divs will never get this big but this doesn't matter*/
    transition: max-height 1s ease-in;
    overflow: hidden;
  }

  .collapsed {
    max-height: 0;
    transition: max-height 1s ease-out;
    overflow: hidden;
  }

  .menulink {
    margin-bottom: 10px;
    font-size: 18px;
    text-decoration: none;
    color: cornflowerblue;
  }

  .deletelink, .addproduct {
    font-size: 10px;
    margin-left: 20px;
    margin-top: -4px;
    text-decoration: none;
    color: cornflowerblue;
  }

    .deletelink a:hover, .addproduct a:hover {
      text-decoration: underline;
    }

  .addsubcat {
    font-size: 12px;
    text-decoration: none;
    color: cornflowerblue;
  }

  .delcat {
    font-size: 10px;
    text-decoration: none;
    color: cornflowerblue;
  }

  .nextline {
    clear: both;
  }
</style>



// WEBPACK FOOTER //
// src/Comp_TreeView.vue